// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609162304/js/" + chunkId + "." + {"44":"1566edf0","225":"72c84219","481":"fdfffc6a","486":"576e25cb","770":"f0c1cf4a"}[chunkId] + ".0.42463697090398156.chunk.js";
};